import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Row, Table,
} from 'reactstrap';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import { deleteCountry, fetchCountry } from '../../actions/countries';
import Can from '../../components/can';
import PinModal from '../../components/pin';

class Country extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.failedDelete = this.failedDelete.bind(this);
  }

  componentWillMount() {
    const { getCountry } = this.props;
    getCountry();
  }

  requestDelete(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedDelete() {
    this.setState({
      submitted: false,
    });
  }

  handleDelete() {
    const { deleteCountryAction, goToList } = this.props;
    deleteCountryAction().then(() => goToList());
  }

  render() {
    const { submitted } = this.state;
    const { country } = this.props;
    if (!country || Object.keys(country).length === 0) {
      return (null);
    }
    return (
      <div className="animated fadeIn">
        {
          submitted
          && <PinModal successSubmit={this.handleDelete} failedSubmit={this.failedDelete} />
        }
        <Row>
          <Col lg={6}>
            <Card>
              <CardHeader>
                <strong>
                  {'Country ID: '}
                  {country.id}
                </strong>
                <div className="card-header-actions">
                  <Can I="update" a="Country">
                    <Button href={`/#/countries/${country.id}/edit`} color="link" className="card-header-action btn-setting">
                      <i className="icon-note" />
                    </Button>
                  </Can>
                  <Can I="delete" a="Country">
                    <Button color="link" className="card-header-action btn-setting" onClick={e => this.requestDelete(e)}>
                      <i className="icon-trash" />
                    </Button>
                  </Can>
                </div>
              </CardHeader>
              <CardBody>
                <Table responsive striped hover>
                  <tbody>
                    <tr key="id">
                      <td>Country ID:</td>
                      <td><strong>{country.id}</strong></td>
                    </tr>
                    <tr key="name">
                      <td>Country Name:</td>
                      <td><strong>{country.name}</strong></td>
                    </tr>
                    <tr key="name">
                      <td>Continent:</td>
                      <td><strong>{country.continent && country.continent.name}</strong></td>
                    </tr>
                    <tr key="name">
                      <td>ISO Country Code:</td>
                      <td><strong>{country.ISOcountryCode}</strong></td>
                    </tr>
                    <tr key="name">
                      <td>Daylight Saving:</td>
                      <td><strong>{country.daylightSaving}</strong></td>
                    </tr>
                    <tr key="name">
                      <td>Calculation Method:</td>
                      <td>
                        <strong>
                          {country.calculationMethod && country.calculationMethod.name}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <Button href={`/#/countries/${country.id}/edit`} color="secondary" size="sm">Edit</Button>
                {' '}
                <Button color="danger" onClick={e => this.requestDelete(e)} size="sm">Delete</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

Country.propTypes = {
  deleteCountryAction: PropTypes.func.isRequired,
  getCountry: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  country: PropTypes.shape,
};

Country.defaultProps = {
  country: {},
};

const mapStateToProps = ({ countries }) => ({
  country: countries.item,
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  deleteCountryAction: () => deleteCountry(ownProps.match.params.id),
  getCountry: () => fetchCountry(ownProps.match.params.id),
  goToList: () => goBack(),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Country);
